/**
 * Validates and sanitizes a URL to prevent XSS attacks.
 *
 * @param url - The URL to validate and sanitize
 * @returns The sanitized URL or empty string if unsafe
 *
 */
export const validateAndSanitizeUrl = (url: string): string => {
	if (!url || typeof url !== 'string') {
		return '';
	}
	url = url.trim();
	try {
		// In case of SSR, global window may not have been initialized
		const baseUrl = typeof window !== 'undefined' ? window.location.origin : undefined;
		const parsed = new URL(url, baseUrl);
		if (!['http:', 'https:', 'mailto:', 'tel:'].includes(parsed.protocol)) {
			return '';
		}

		return parsed.href;
	} catch {
		return '';
	}
};
